/* src/app/warehousing/pages/report-movement-history/report-movement-history.component.scss */
/*# sourceMappingURL=report-movement-history.component.css.map */
